// import _ from 'lodash';
// import { addLocaleData } from 'react-intl';
import Emitter from '../../services/emitter';
import Storage from '../../services/api/store';
import CONSTANT from '../../constant';
import Languages, { supportLangKeys, updateLocaleData, readyLangKeys, getDefaultLang} from '../../locales';

// 切换语言
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';

// 语言列表
export const defaultLangKey = getDefaultLang(supportLangKeys);
export const langKey = getDefaultLang(readyLangKeys);
export const defaultMessages = Languages[langKey].messages;
/**
 * 获取 语言相关数据
 *
 * @param {any} lang
 * @returns
 */
export const getLanguageData = async (lang = langKey) => {
    if (supportLangKeys.indexOf(lang) === -1) {
        lang = supportLangKeys[0];
    }
    await updateLocaleData(lang);
    Storage.set(CONSTANT.INTL_LANG_KEY, lang);
    return Languages[lang].messages;
};

const updateLang = (langKey, messages) => {
    return {
        type: SWITCH_LANGUAGE,
        payload: {
            langKey,
            messages
        }
    };
};

/**
 * 切换语言
 *
 * @param {any} langKey
 * @returns
 */
const change = (langKey) => {
    return dispatch => {
        getLanguageData(langKey).then(messages => {
            Emitter.emit('SwitchLanguage', langKey);
            return dispatch(updateLang(langKey, messages));
        });
    };
};

export default {
    change
};
